import fetch from '@/utils/fetch'

const file = {
  state: {
  },

  mutations: {
  },

  getters: {
  },

  actions: {
    getFileContent: async ({ state, dispatch, commit }, data) => {
      let url = `/getFile`
      const res = await fetch.post(url, data)
      return res
    }
  }
}

export default file
